import React from "react";
import BottomSheet from "../../BottomSheet";
import Button from "../../Button";

interface CGMClearRestartBottomSheetProps {
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const CGMClearRestartBottomSheet: React.FC<CGMClearRestartBottomSheetProps> = ({
  show,
  onConfirm,
  onCancel,
}) => {
  return (
    <BottomSheet
      show={show}
      title="Reset & reconnect?"
      handleClose={onCancel}
      zIndex={60}
    >
      <div className="p-4">
        <p className="text-sm text-gray-500">
          This will reset your CGM connection and you&apos;ll need to go through
          the full setup again including a new warm-up period.
        </p>
        <div className="flex gap-3 mt-4">
          <Button
            onClick={onCancel}
            variant="outlined"
            rounded="full"
            fullWidth
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            variant="contained"
            rounded="full"
            fullWidth
          >
            Reset &amp; Reconnect
          </Button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default CGMClearRestartBottomSheet;
